export default {
    name: 'ru',
    moment: {
        durationLabelsStandard: {
            d: 'день',
            dd: 'дня',
            ddd: 'дней',
            h: 'час',
            hh: 'часа',
            hhh: 'часов',
            m: 'минута',
            mm: 'минуты',
            mmm: 'минут',
            s: 'секунда',
            ss: 'секунды',
            sss: 'секунд',
        },
        durationLabelsShort: {
            d: 'д',
            dd: 'д',
            ddd: 'д',
            h: 'ч',
            hh: 'ч',
            hhh: 'ч',
            m: 'м',
            mm: 'м',
            mmm: 'м',
            s: 'с',
            ss: 'с',
            sss: 'с',
        },
        durationPluralKey: function (token, integerValue, decimalValue) {
            // Decimal value does not affect unit label for this locale.

            // "xxx" for > 2.
            if (integerValue > 4) {
                return token + token + token;
            }

            // "x" for === 1.
            if (integerValue === 1) {
                return token;
            }

            // "xx" for others.
            return token + token;
        }
    },
    validation: {
        custom: {
            current_password: {
                confirmed: "Подтверждение пароля не совпадает"
            },
            password: {
                confirmed: "Подтверждение пароля не совпадает",
                min: (_, value) => {
                    return `Длина должна быть не менее ${value} символов.`
                }
            }
        },
    },
    messages: {
        surveys: {
            question: {
                generated: "🤖 Автоматически генерируемые",
                type: {
                    radio: "Один ответ",
                    checkbox: "Несколько",
                    text: "Текст",
                    short: "Короткий ответ",
                    "generated-courses": "Кафедральные курсы",
                }
            }
        },
        attachments: {
            suffixes: {
                kb: "КБ",
                mb: "МБ",
                gb: "ГБ",
            }
        },
        error: {
            unexpected: "Произошла непредвиденная ошибка",
            invalid: "Необходимо исправить все ошибки",
            validate: "Необходимо указать верные данные",
            'select-all': "Необходимо выбрать все поля",
        },
        users: {
            profile: {
                type: {
                    associate: "Сотрудник",
                    teacher: "Преподаватель",
                    bachelor: "Бакалавр",
                    master: "Магистр",
                    graduate: "Аспирант",
                }
            }
        },
        roles: {
            scopes: {
                student_type: {
                    title: "Вид подготовки"
                },
                student_enrollment_year: {
                    title: "Год начала обучения"
                },
                department_id: {
                    title: "Кафедра"
                },
                groups: {
                    title: "Группы"
                },
                subject_type: {
                    title: "Тип предмета",
                    type: {
                        linguistic: "Язык"
                    }
                }
            },
            type: {
                employee: 'Сотрудники',
                student: 'Учащиеся',
                tag: 'Тэг',
            }
        },
        students: {
            type: {
                title: "Вид подготовки",
                bachelor: "Бакалавриат",
                master: "Магистратура",
                graduate: "Аспирантура",
                aspirant: "Соискатель",
                additional_education: "Дополнительное образование",
            }
        },
        groups: {
            title: "Группа",
            type: {
                title: "Тип группы",
                regular: "Учебная группа",
                linguistic: "Языковая группа",
                optional: "Курс по выбору",
            }
        },
        subjects: {
            title: "Предмет",
            type: {
                main: "Основная",
                department: "Дисциалина кафедры",
                generic: "Другое (практика, аттестация и т.п.)",
            },
            part: {
                base: "Базовая",
                variable: "Вариативная"
            },
            main: {
                linguistic: {
                    title: "Языковой",
                    undefined: 'Нет',
                    null: 'Нет',
                    primary: "Первый",
                    secondary: "Второй"
                }
            },
            details: {
                lecture: "Лекция",
                seminar: "Семинар",
                practice: "Практическое занятие",
            }
        },
        courses: {
            title: "Курс",
            any: "Любой курс",
            number: "{number} курс",
        },
        semesters: {
            title: "Семестр",
            any: "Любой семестр",
            number: "{number} семестр",
        },
        reports: {
            model: {
                user: {
                    create: "Создание пользователей",
                    delete: "Удаление пользователей",
                    archive: "Архивирование пользователя",
                    restore: "Восстановление пользователя",
                },
                subject: {
                    create: "Создание предмета",
                    update: "Изменение предмета",
                    delete: "Удаление предмета",
                },
                group: {
                    create: "Создание группы",
                    update: "Изменение группы",
                    delete: "Удаление группы",
                    'students-add': "Добавление студентов",
                    'students-delete': "Удаление студентов",
                },
                schedule: {
                    create: "Создание расписания",
                    update: "Изменение расписания",
                    duplicate: "Дублирование расписания",
                    archive: "Архивирование расписания",
                    restore: "Восстановление расписания",
                    delete: "Удаление расписания",
                },
                'schedule-entry': {
                    create: "Создание занятия",
                    update: "Изменение занятия",
                    delete: "Удаление занятия",
                },
                attachment: {
                    create: "Загрузка прикрепления",
                    update: "Изменение прикрепления",
                    delete: "Удаление прикрепления",
                },
                survey: {
                    create: "Создание анкеты",
                    update: "Изменение анкеты",
                    duplicate: "Дублирование анкеты",
                    delete: "Удаление анкеты",
                },
                quiz: {
                    create: "Создание теста",
                    update: "Изменение теста",
                    duplicate: "Дублирование теста",
                    delete: "Удаление теста",
                },
                'library_category': {
                    create: "Создание раздела книжного клуба",
                    update: "Изменение раздела книжного клуба",
                    delete: "Удаление раздела книжного клуба",
                },
                article: {
                    create: "Создание публикации",
                    update: "Изменение публикации",
                    publish: "Публикация публикации",
                    delete: "Удаление публикации",
                },
            }
        },
        schedule: {
            subject_type: "Тип занятия",
            subject: "Дисциплина",
            parity: "Четность (с начала учебного года)",
            groups: "Группы",
            classtime: "Время занятия",
            classroom: "Аудитория",
            teacher: "Преподаватель",
            begin_at: "Дата начала занятия",
            group_type: {
                'regular': 'Семинарских групп',
                'linguistic-primary': 'Первого языка',
                'linguistic-secondary': 'Второго языка',
                'bachelor': 'Кафедры',
                'master': 'Магистерских программ',
                'graduate': 'Аспирантурских профилей',
                'optional': 'Курсов по выбору',
            },
            group_description: {
                'regular': 'Семинарские группы',
                'linguistic-primary': 'Первый иностранный язык',
                'linguistic-secondary': 'Второй иностранный язык',
                'bachelor': 'Дисциплины кафедры',
                'master': 'Магистерские программы',
                'graduated': 'Аспирантурские профили',
                'optional': 'Курсы по выбору',
            },
        },
        dates: {
            days: {
                monday: "Понедельник",
                tuesday: "Вторник",
                wednesday: "Среда",
                thursday: "Четверг",
                friday: "Пятница",
                saturday: "Суббота",
                sunday: "Воскресенье",
            },
            days_short: {
                monday: "Пн",
                tuesday: "Вт",
                wednesday: "Ср",
                thursday: "Чт",
                friday: "Пт",
                saturday: "Сб",
                sunday: "Вс",
            },
            months: {
                january: "Январь",
                february: "Февраль",
                march: "Март",
                april: "Апрель",
                may: "Май",
                june: "Июнь",
                july: "Июль",
                august: "Август",
                september: "Сентябрь",
                october: "Октябрь",
                november: "Ноябрь",
                december: "Декабрь",
            },
        },
        news: {
            sections: {
                feed: 'Новости факультета',
                media: 'ФМП в СМИ',
                announcements: 'Объявления',
                authored: 'Мои публикации',
                search: 'Поиск',
                favorites: 'Избранное',
                'my-events': 'Мои события',
            },
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/locale/ru.js